import { OrganizationTemplateCard } from '../organization-cta-card/OrganizationTemplateCard';
import OrganizationLinkCard from '../organization-cta-card/OrganizationLinkCard';
import { Title } from '../../../components/typography/Heading';
import RoundedButtonLinkPrimary from '../../../components/button/rounded-button-link-primary/RoundedButtonLinkPrimary';
import {
    OrganizationTheme,
    SECONDARY_ORGANIZATION_COLOR,
    TERTIARY_ORGANIZATION_COLOR,
} from '../../theme/OrganizationTheme';
import { WaveBackground } from './WaveBackground';
import { OrganizationCauseTitle } from './OrganizationCauseTitle';
import styles from './organization-cta-templates.module.less';

const Campaigns = ({ templateCauses, pageLinks }) => {
    return (
        <>
            {templateCauses.map((cause) => (
                <OrganizationTemplateCard
                    key={cause.id}
                    causeId={cause.id}
                    templateId={cause.template_id}
                    title={cause.title}
                    description={cause.description}
                    img_url={cause.img_url}
                    dugnad={cause.dugnad}
                    birthday={cause.birthday}
                    params={cause.params}
                    customLink={cause.profile?.customLink}
                    customLinkText={cause.profile?.customLinkText}
                    startProjectText={cause.profile?.startProjectText}
                    redirectToPreview={cause.profile?.redirectToPreview}
                    schoolId={cause.schoolId}
                    causeType={cause.type}
                />
            ))}
            {pageLinks?.map((pageLink, idx) => (
                <OrganizationLinkCard
                    className={styles.linkButton}
                    key={'pageLink' + idx}
                    title={pageLink.title}
                    banner={pageLink.banner}
                    description={pageLink.description}
                    link={pageLink.link}
                    linkText={pageLink.linkText}
                />
            ))}
        </>
    );
};

const NoCampaigns = ({ organizationId }) => {
    return (
        <div className={styles.noCampaigns}>
            <Title>Dere har ingen aktive aksjoner</Title>
            <p>
                For å gjøre det enkelt for innsamlere å lage spleiser til sakene som er viktigst for dere, kan dere
                legge til inntil seks aksjoner med innsamlingsmaler de kan velge mellom
            </p>
            <RoundedButtonLinkPrimary to={`/org/${organizationId}/control/causes`}>
                Opprett en aksjon
            </RoundedButtonLinkPrimary>
        </div>
    );
};

export const OrganizationCtaTemplates = ({
    templateCauses = [],
    pageLinks = [],
    userIsOrganizationMember = false,
    organizationId,
    editable,
}) => {
    const hasTemplates = templateCauses.length + pageLinks.length > 0;

    let content = null;

    if (hasTemplates) {
        content = <Campaigns templateCauses={templateCauses} pageLinks={pageLinks} />;
    } else if (userIsOrganizationMember) {
        content = <NoCampaigns organizationId={organizationId} />;
    } else {
        return null;
    }

    return (
        <OrganizationTheme className={styles.ctaTemplate} theme={SECONDARY_ORGANIZATION_COLOR}>
            <div className={[styles.waveTop, SECONDARY_ORGANIZATION_COLOR].join(' ')}></div>
            <div className={[styles.waveContainer, TERTIARY_ORGANIZATION_COLOR].join(' ')}>
                <WaveBackground />
            </div>
            <div className={[styles.waveBottom, TERTIARY_ORGANIZATION_COLOR].join(' ')}></div>
            <OrganizationCauseTitle editable={editable} />
            <div className={styles.ctaTemplateCardCenter}>
                <div
                    className={[
                        templateCauses.length === 4 ? styles.fourCards : '',
                        styles.ctaTemplateCardContainer,
                    ].join(' ')}
                >
                    {content}
                </div>
            </div>
        </OrganizationTheme>
    );
};

export default OrganizationCtaTemplates;
